import React, { useEffect, useState } from "react";
import AgoraRTC from "agora-rtc-sdk";
import { useTranslation } from "react-i18next";
import { auth } from "../../../auth/broadcaster";
import MenuSystem from "../../../layout/Menu-system";
import { Container } from "./styles";
import { SystemButton } from "../../../components/buttons/styles";
import TranslationLogo from "../../../assets/icon-translation.svg";
import live from "../../../assets/icon-live.svg";
import audioIcon from "../../../assets/icon-audio-2.svg";

const ClientTranslate = () => {
  // useEffect(() => {
  //   window.location.href =
  //     "https://app.beplay.io/categories/4/events/122/room/1/region/1/idioma/5/accessibility/4/professional/171/audio";
  // });

  const { t } = useTranslation();
  const [start, setStart] = useState(false);
  const [activate, setActivate] = useState({
    backgroundColor: "",
    border: "",
    color: "",
    title: t("client-btn-start-transmission"),
  });

  const appId = auth.appId;
  const channel = auth.channelTranslate;
  const config = {
    mode: "live",
    codec: "h264",
  };

  const handleError = (err) => {
    console.log("Error: ", err);
  };

  const client = AgoraRTC.createClient(config);

  const handleStartClient = () => {
    if (!start) {
      setStart(true);
      setActivate({
        backgroundColor: "transparent",
        border: "1px solid #fff",
        color: "#fff",
        title: t("client-btn-finish-transmission"),
      });

      client.init(
        appId,
        () => {
          console.log("Audience initialized");
          joinChannel();
        },
        handleError
      );

      client.on("stream-published", function (evt) {
        console.log("Publish local stream successfully");
      });

      client.on("stream-added", function (evt) {
        let stream = evt.stream;
        let streamId = stream.getId();
        console.log("New stream added: " + streamId);
        console.log("Subscribing to remote stream:" + streamId);
        // Subscribe to the stream.
        client.subscribe(stream, handleError);
      });

      client.on("stream-removed", function (evt) {
        let stream = evt.stream;
        stream.stop(); // stop the stream
        stream.close(); // clean up and close the camera stream
        console.log("Remote stream is removed " + stream.getId());
      });

      client.on("stream-subscribed", function (evt) {
        let remoteStream = evt.stream;
        remoteStream.play("play");
        console.log(
          "Successfully subscribed to remote stream: " + remoteStream.getId()
        );
      });

      client.on("peer-leave", function (evt) {
        console.log("Remote stream has left the channel: " + evt.uid);
        evt.stream.stop(); // stop the stream
      });

      function joinChannel() {
        client.setClientRole(
          "audience",
          () => {
            console.log("Client set as a audience");
          },
          handleError
        );

        client.join(
          null,
          channel,
          null,
          (uid) => {
            console.log("User " + uid + " join channel successfully");
          },
          handleError
        );
      }
    } else {
      setActivate({
        backgroundColor: "",
        border: "",
        color: "",
        title: t("client-btn-start-transmission"),
      });
      setStart(false);
      window.location.reload();
    }
  };
  return (
    <Container>
      <MenuSystem url="/tbsp" />
      <div className="systemTransmission">
        <div className="systemInfo">
          {!start && (
            <>
              <img src={TranslationLogo} alt="ícone da audio" />
              {/* <h3>AD + Áudio Original</h3> */}
              <h3>{t("trad-portugues")}</h3>
              {/* <h3>Comunicação interna</h3> */}
              {/* <p>{t("client-ad-text1")}</p> */}
              <p>{t("client-translate-text")}</p>
            </>
          )}

          {start && (
            <>
              <div className="live">
                <p className="live-paragraph">{t("receive-trad-port")}</p>
                <img src={live} alt="ícone ao vivo" />
              </div>
            </>
          )}
          <SystemButton style={activate} onClick={() => handleStartClient()}>
            {activate.title}
          </SystemButton>
        </div>
      </div>

      <div id="play"></div>
    </Container>
  );
};
export default ClientTranslate;
